<template>

    <div id="fastcheckout" class="fc__view">
        <div class="team__intro">
            <h3>{{ trans('distrib.orders.title') }}</h3>
        </div>

        <div class="team__intro__row">
            <div>
                <div class="card card--team__intro">
                    <span>{{ num_fastcheckouts }}</span>
                    <p>{{ trans('distrib.orders.req') }}</p>
                </div>
                <div class="card card--team__intro">
                    <span>{{ num_orders }}</span>
                    <p>{{ trans('distrib.orders.ord') }}</p>
                </div>
            </div>
            <a v-if="this.vuedata.is_admin" class="btn btn-primary  " data-bs-toggle="modal" data-bs-target="#fastcheckoutmodal">{{ trans('distrib.orders.fc.trigger') }}</a>
        </div>

        <div id="fastcheckoutmodal" class="modal modal--fordistrib fade in" data-keyboard="false" tabindex="-1">
            <div class="vertical-alignment-helper">
                <div class="modal-dialog vertical-align-center">
                    <div v-if="this.status.code === 0">
                        <div v-if="this.incompleteDistributor" class="modal-content fc__blocker">
                            <div class="modal__messages">
                                <p class="title">{{ trans('distrib.orders.fc.trigger2') }}</p>
                                <div class="fc__phases__wrapper">
                                    <div class="fc__phase">
                                        <p class="title__2">{{ trans('distrib.orders.fc.inc.title') }}</p>
                                        <div class="fc__phase__body">
                                            <img src="/images/icon_warning_black.svg" width="200px" alt="">
                                            <p>{{ trans('distrib.orders.fc.inc.sub') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal__actions">
                                <a class="link link--reject" data-bs-dismiss="modal">{{ trans('distrib.orders.fc.nav.back') }}</a>
                                <a class="link link--accept" href="/biomemakers-client-profile">{{ trans('distrib.orders.fc.inc.cta') }}</a>
                            </div>
                        </div>
                        <div v-else class="modal-content fc__process">
                            <div class="modal__messages">
                                <p class="title">{{ trans('distrib.orders.fc.trigger2') }}</p>
                                <div class="fc__phases__wrapper">
                                    <div v-if="this.current_phase === 1" class="fc__phase fc__phase--grid">
                                        <p class="title__2">{{ trans('distrib.orders.fc.ph_dest.title') }}</p>
                                        <p class="subtitle">
                                            {{ trans('distrib.orders.fc.ph_dest.sub') }}
                                        </p>
                                        <p class="emph">{{ trans('distrib.orders.fc.ph_dest.emp') }}</p>
                                        <div class="fc__phase__body">
                                            <ul :class="myGridClass">
                                                <li v-for="(client, index) in vuedata.client_list" :key="index" :class="{selected: client.id === final_client_id, deslocated: !client.addresses.length}" @click="selectClient(client.id)">
                                                    <a href="#">
                                                        <figure>
                                                            <img :src="'/client.pic/' + client.id + '/photo.jpg?square=true'" />
                                                            <figcaption>{{ client.name }}</figcaption>
                                                        </figure>
                                                    </a>
                                                </li>
                                            </ul>
                                            <p class="warning" :class="{deployed: this.noAddresses}"><i class="icon-bc-warning"></i> {{ trans('distrib.orders.fc.ph_dest.warn') }}</p>
                                        </div>
                                    </div>
                                    <div v-else-if="this.current_phase === 2" class="fc__phase fc__phase--bulks">
                                        <p class="title__2">{{ trans('distrib.orders.fc.ph_bulks.title') }}</p>
                                        <p class="subtitle">{{ trans('distrib.orders.fc.ph_bulks.sub') }}</p>
                                        <p class="emph">{{ trans('distrib.orders.fc.ph_bulks.emp') }}</p>
                                        <div class="fc__phase__body">
                                            <div class="table__wrapper" :class="{triggeredover: this.bulks.length > 5}">
                                                <table>
                                                    <tbody>
                                                        <tr v-for="(bulk, idx) in bulks" :key="idx">
                                                            <td><span class="num">{{ (idx + 1) }}</span></td>
                                                            <td>
                                                                <img :src="getIcon(bulk.type_id)" >
                                                            </td>
                                                            <td class="has__select">
                                                                <div class="select__wrapper">
                                                                    <easy-select :nullable="false" v-model="bulk.type_id" :options="bulk.type_list"></easy-select>
                                                                </div>
                                                                <i class="icon-anita-arrow_down"></i>
                                                            </td>
                                                            <td class="no_border"></td>
                                                            <td>
                                                                <input v-model="bulk.num" type="number" min="1" class="num">
                                                            </td>
                                                            <td class="no_border">
                                                                <a v-if="bulks.length>1" @click.prevent="rmBulk(idx)">
                                                                    <i class="icon-bc-cross-raw"></i>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <a @click.prevent="addBulk" class="btn btn-primary btn--small btn--squared">
                                                <i class="icon-bc-plus"></i>
                                            </a>
                                        </div>
                                    </div>
                                    <div v-else-if="this.current_phase === 3" class="fc__phase fc__phase--sh">
                                        <p class="title__2">{{ trans('distrib.orders.fc.ph_sh.title') }}</p>
                                        <p class="subtitle">{{ trans('distrib.orders.fc.ph_sh.sub') }}</p>
                                        <div class="fc__phase__body">
                                            <div class="block__adr">
                                                <p class="title__2">{{ trans('distrib.orders.fc.ph_sh.title_sh') }}</p>
                                                <div class="adr__sel">
                                                    <img :src="shipping_address_client_pic">
                                                    <select v-model="shipping_address" >
                                                        <option v-for="(addr, index) in shipping_addresses" :value="addr" :key="index">
                                                            {{addr.address}}
                                                        </option>
                                                    </select>
                                                    <i class="icon-anita-arrow_down"></i>
                                                </div>
                                            </div>
                                            <div class="block__adr">
                                                <p class="title__2">{{ trans('distrib.orders.fc.ph_sh.title_bi') }}</p>
                                                <div class="adr__sel">
                                                    <img :src="billing_address_client_pic">
                                                    <select v-model="billing_address" >
                                                        <option v-for="(addr, index) in billing_addresses" :value="addr" :key="index">
                                                            {{addr.address}}
                                                        </option>
                                                    </select>
                                                    <i class="icon-anita-arrow_down"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="this.current_phase === 4" class="fc__phase fc__phase--summary">
                                        <p class="title__2">{{ trans('distrib.orders.fc.summ.title') }}</p>
                                        <p class="subtitle">{{ trans('distrib.orders.fc.summ.sub') }}</p>
                                        <div class="fc__phase__body">
                                            <div class="summ__row">
                                                <div class="heading">
                                                    <p class="row__title">{{ trans('distrib.orders.fc.summ.summ_to') }}:</p>
                                                    <p>{{finalClientName}}</p>
                                                </div>
                                                <img src="">
                                            </div>
                                            <div class="summ__row">
                                                <div class="heading">
                                                    <p class="row__title">{{ trans('distrib.orders.fc.summ.summ_items') }}:</p>
                                                    <p>{{totalSamples}} {{ trans('distrib.orders.fc.summ.summ_units') }}</p>
                                                </div>
                                                <div class="table__wrapper">
                                                    <table>
                                                        <tbody>
                                                            <tr v-for="(bulk, idx) in bulks" :key="idx">
                                                                <td>{{ (idx + 1) }}</td>
                                                                <td>{{getBulkName(bulk.type_id)}}</td>
                                                                <td>{{bulk.num}}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div class="summ__row">
                                                <p class="row__title">{{ trans('distrib.orders.fc.summ.summ_sh') }}</p>
                                                <p>{{myshipping}}</p>
                                            </div>
                                            <div class="summ__row">
                                                <p class="row__title">{{ trans('distrib.orders.fc.summ.summ_bi') }}</p>
                                                <p>{{mybilling}}</p>
                                            </div>
                                            <div class="summ__row">
                                                <p class="row__title">{{ trans('distrib.orders.fc.summ.summ_comm') }}</p>
                                               <textarea v-model="comments"> </textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <modal-navig :phase="current_phase" :total="total_phases"
                                        @move-back="moveBack"
                                        @move-forward="moveForward"
                                        @jump-stage="moveStage">
                                    </modal-navig>
                                </div>
                            </div>
                            <div class="modal__actions">
                                <a class="modal__button modal__button--no" data-bs-dismiss="modal">{{ trans('distrib.orders.fc.nav.back') }}</a>
                                <a class="modal__button modal__button--ok js_ok" :class="{ready: this.isReady }" @click.prevent="placeOrder">{{ trans('distrib.orders.fc.nav.create') }}</a>
                            </div>
                        </div><!-- /.modal-content -->
                    </div>
                    <div v-else>
                        <div v-if="this.status.code === 1" class="modal-content fc__success">
                            <div class="modal__messages">
                                <p class="title">{{ trans('distrib.orders.fc.succ.title') }}</p>
                                <div class="fc__phases__wrapper">
                                    <div class="fc__phase">
                                        <div class="fc__phase__body">
                                            <p>{{ trans('distrib.orders.fc.succ.sub') }}</p>
                                            <img src="/images/icon_check_black.svg" width="200px" alt="">
                                            <p>{{ trans('distrib.orders.fc.succ.sub__2') }} <a href="/orders/requests" class="link link--accept">{{ trans('distrib.orders.fc.succ.link') }}</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal__actions">
                                <a class="modal__button modal__button--ok js_ok ready" href="/orders/requests">{{ trans('distrib.orders.fc.nav.ok') }}</a>
                            </div>
                        </div>
                        <div v-else-if="this.status.code === 2" class="modal-content fc__fail">
                            <div class="modal__messages">
                                <p class="title">{{ trans('distrib.orders.fc.trigger2') }}</p>
                                <div class="fc__phases__wrapper">
                                    <div class="fc__phase">
                                        <p class="title__2">{{ trans('distrib.orders.fc.err.title') }}</p>
                                        <div class="fc__phase__body">
                                            <p>{{ trans('distrib.orders.fc.err.sub') }}</p>
                                            <img src="/images/icon_warning_black.svg" width="200px" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal__actions">
                                <a class="modal__button modal__button--ok js_ok ready" href="/orders/requests">{{ trans('distrib.orders.fc.nav.ok') }}</a>
                            </div>
                        </div>
                        <div v-else-if="this.status.code === 3" class="modal-content fc__creating">
                            <div class="modal__messages">
                                <p class="title">{{ trans('distrib.orders.fc.trigger2') }}</p>
                                <div class="fc__phases__wrapper">
                                    <div class="fc__phase">
                                        <p class="title__2">{{ trans('distrib.orders.fc.load.title') }}</p>
                                        <div class="fc__phase__body">
                                            <div class="modal__loader">
                                                <div class="becrop__loader__wrapper" style="height: 64px; width: 64px;">
                                                    <div class="becrop__loader" style="height: 64px; width:64px">
                                                        <div class="semicircle" style="-webkit-border-radius: 0 0 64px 64px; border-radius: 0 0 64px 64px">
                                                        </div>
                                                    </div>

                                                    <div class="becrop__line__loader" style="height: 64px; width:64px">
                                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve" style="height: 64px; width:64px">
                                                            <line class="first" stroke="#ffffff" x1="42.7" y1="7.3" x2="7.3" y2="42.7"></line>
                                                            <line class="second" stroke="#ffffff" x1="42.7" y1="7.3" x2="7.3" y2="42.7"></line>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                            <p>{{ trans('distrib.orders.fc.load.sub') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div><!-- /.modal-dialog -->
            </div>
        </div>

        <!-- CHANGE FOR VUEDATA.FASTCHECKOUTS-->
        <order-tables
            :fastcheckouts="vuedata.fastcheckouts"
            :orders="vuedata.orders"
            :becrop_types="vuedata.becrop_types"
            :active_tab="vuedata.active_tab"
            :is_biome="vuedata.is_biome"
            :is_distributor="vuedata.is_distributor"
        ></order-tables>

    </div>
</template>

<script>

import {includes as _includes} from 'lodash';

function prepare_addr(addr) {
    if (!addr) return null;

    const addr2 = { ...addr };
    delete addr2.is_billing;
    delete addr2.is_shipping;
    return addr2;
}

function getQueryVariable(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return null;
}

export default {

    props: {
        vuedata: {},
    },

    data() {
        return {

            shipping_addresses: [],
            billing_addresses: [],

            shipping_address_client_pic: null,
            billing_address_client_pic: null,
            shipping_address: null,
            billing_address: null,

            final_client_id: this.vuedata.client_list[0].id,
            bulks: [this.createBulk()],
            comments: '',

            current_phase: 1,
            total_phases: 4,

            num_fastcheckouts: this.vuedata.fastcheckouts.length,
            num_orders: this.vuedata.orders.length,

            // CODES:
            // 0 > In the Process
            // 1 > Success
            // 2 > Error
            // 3 > Loading

            status: {
                code: 0,
                msg: ''
            },

        };
    },

    computed: {

        myGridClass() {
            let baseClass = 'column--';
            if (this.vuedata.client_list.length > 3) baseClass = baseClass + '4';
            else baseClass = baseClass + this.vuedata.client_list.length.toString();
            return baseClass;
        },

        finalClientName() {
            const client = this.vuedata.client_list.find((cli) => cli.id === this.final_client_id);
            return client.name;
        },

        totalSamples() {
            const reducer = (accumulator, currentValue) => accumulator + currentValue.num;
            return this.bulks.reduce(reducer, 0);
        },

        myshipping() {
            if (this.shipping_address != null) return this.shipping_address.address;
        },

        mybilling() {
            if (this.billing_address != null) return this.billing_address.address;
        },

        incompleteDistributor() {
            let incomplete = true;
            if (this.vuedata.client_list[0].addresses.length > 0) incomplete = false;
            return incomplete;
        },

        noAddresses() {
            const cli = this.vuedata.client_list.find(mycli => mycli.id === this.final_client_id);
            return cli.addresses.length === 0;
        },

        isReady() {
            let isready = false;
            if (this.final_client_id != null && this.bulks.length > 0 && this.shipping_address != null && this.billing_address != null && this.current_phase === 4) {
                isready = true;
            }

            return isready;
        },

        // Just for the watch
        bulkSelectedTypes() {
            return this.bulks.map(b => b.type_id);
        }

    },

    mounted() {
        // Launch the modal

        if (getQueryVariable('newrequest')) {
            $('#fastcheckoutmodal').modal();
        }

        this.updateAddresses();
    },

    watch: {
        final_client_id() {
            this.updateAddresses();
        },

        shipping_address() {
            if (!this.shipping_address) return;

            const client_id = this.shipping_address.is_from_subclient
                ? this.final_client_id
                : this.vuedata.client_list[0].id;

            this.shipping_address_client_pic = `/client.pic/${client_id}/photo.jpg?square=true`;
        },

        billing_address() {
            if (!this.billing_address) return;

            const client_id = this.billing_address.is_from_subclient
                ? this.final_client_id
                : this.vuedata.client_list[0].id;

            this.billing_address_client_pic = `/client.pic/${client_id}/photo.jpg?square=true`;
        },

        bulkSelectedTypes() {
            this.updateBulkTypes();
        },

    },

    methods: {

        addBulk() {
            this.bulks.push(this.createBulk());
        },

        createBulk() {
            // The first bulk does no have not allowed
            const notallowed = this.bulkSelectedTypes
                ? this.bulkSelectedTypes.map(x => x)
                : [];

            // Build a list of types
            const type_list = this.vuedata.becrop_types.map(t => ({
                label: t.name,
                value: t.type_id,
            })).filter(type => {
                return !_includes(notallowed, type.value);
            });

            return {
                num: 10,
                type_id: type_list[0].value,
                type_list,
            };
        },

        rmBulk(idx) {
            this.bulks.splice(idx, 1);
        },

        async updateBulkTypes() {
            const type_list = this.vuedata.becrop_types.map(t => ({
                label: t.name,
                value: t.type_id,
            }));

            this.bulks.forEach((bulk, i) => {
                let notallowed = this.bulkSelectedTypes.map(x => x);
                notallowed.splice(i, 1);
                notallowed = notallowed.filter(x => x);

                this.bulks[i].type_list = type_list.filter(type => {
                    return !_includes(notallowed, type.value) || type.value === this.bulkSelectedTypes[i];
                });
            });
        },

        getIcon(type_id) {
            let found = this.vuedata.becrop_types.find(type => type.type_id === type_id);
            if (!found) found = this.vuedata.becrop_types[0];

            return found.icon;
        },

        async placeOrder() {
            // console.log("Placing order");

            const data = {
                final_client_id: this.final_client_id,
                bulks: this.bulks.map((bulk) => ({ type_id: bulk.type_id, num: bulk.num })),
                shipping_address: prepare_addr(this.shipping_address),
                billing_address: prepare_addr(this.billing_address),
                comments: this.comments,
            };

            try {
                this.status.code = 3;
                this.status.msg = 'Creating';
                await axios.post('/orders/api_place_order', data);
                this.status.code = 1;
                this.status.msg = 'Success';
            } catch (e) {
                console.log(e);
                this.status.code = 2;
                this.status.msg = 'Fail';
            }
        },

        updateAddresses() {
            const my_client_id = this.vuedata.client_list[0].id;

            let shipping_addr = this.retrieveAddresses(my_client_id, true);
            let billing_addr = this.retrieveAddresses(my_client_id, false);

            if (my_client_id !== this.final_client_id) {
                shipping_addr = [...shipping_addr, ...this.retrieveAddresses(this.final_client_id, true, true)];
                billing_addr = [...billing_addr, ...this.retrieveAddresses(this.final_client_id, false, true)];
            }

            this.shipping_addresses = shipping_addr;
            this.billing_addresses = billing_addr;

            this.shipping_address = this.shipping_addresses[0];
            this.billing_address = this.billing_addresses[0];
        },

        retrieveAddresses(client_id, is_shipping = true, is_from_subclient = false) {
            const found = this.vuedata.client_list.find(client => client.id === client_id);
            if (!found) return [];

            const thefilter = addr => ((addr.is_shipping && is_shipping) || (addr.is_billing && !is_shipping));
            return found.addresses.filter(thefilter).map(addr => {
                // Clone to add the is_from_subclient flag
                const obj = JSON.parse(JSON.stringify(addr));
                obj.is_from_subclient = is_from_subclient;
                return obj;
            });
        },

        moveBack() {
            if (this.current_phase > 1) {
                this.current_phase--;
            }
        },

        moveForward() {
            if (this.current_phase < this.total_phases) {
                this.current_phase++;
            }
        },

        selectClient(id) {
            this.final_client_id = id;
        },

        getBulkName(id) {
            const crop = this.vuedata.becrop_types.find((crop) => crop.type_id === id);
            return crop.name;
        },

        moveStage(i) {
            this.current_phase = i;
        },

    }

};

</script>
